import { Environment } from "../enums";

const env = {
  SUPPORT_SOCKET_URL: "https://connect.myhook.site/support",
  // SUPPORT_SOCKET_URL: "http://localhost:8000/support",
  APP_URL: "https://custompage.crmgenix.com",
  // APP_URL: "http://localhost:3002",
  // API_URL: "http://localhost:8000",
  API_URL: "https://connect.myhook.site",
};
export default env;
